// extracted by mini-css-extract-plugin
export default {"headerLogos":"Header_headerLogos__+KuWi","behLogo":"Header_behLogo__jR-8I","clientLogo":"Header_clientLogo__IJVXC"};